import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { safeJsonLd } from "@/lib/structured-data";
import { primaryVideoObject } from "@/lib/video-seo";
import { getNationalStructuredData } from "@/lib/structured-data/national";
import { Header } from "@/components/site/Header";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";

import { Footer } from "@/components/site/Footer";
import {
  ProcedureHero,
  ProcedureComparison,
  ProcedureBackToWork,
  ProcedureRegrow,
} from "@/components/site/ProcedureContent";

const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/procedure")({
  head: () => ({
    links: [{ rel: "canonical", href: "https://restorehair.com/procedure/" }],
    meta: [
      { title: "The RESTORE® Hair Transplant Procedure | No-Shave FUE™" },
      {
        name: "description",
        content:
          "Learn how the RESTORE® No-Shave FUE™ hair transplant procedure works — minimally invasive, natural results, and trusted for over 20,000 procedures.",
      },
      { property: "og:title", content: "The RESTORE® Hair Transplant Procedure | No-Shave FUE™" },
      {
        property: "og:description",
        content:
          "How the RESTORE® No-Shave FUE™ hair transplant procedure works — soft, natural, undetectable results.",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({ "@graph": getNationalStructuredData() }),
      },
      {
        type: "application/ld+json",
        children: safeJsonLd(primaryVideoObject("/procedure/")),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <ProcedureHero />
        <NorwoodQuiz />
        <ProcedureComparison />
        <ProcedureBackToWork />
        <ProcedureRegrow />
        <Suspense fallback={null}>
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
